import { ChangeEvent } from 'react';
import {
	Checkbox,
	Grid,
	Label,
	Spacer,
	Text,
	TextInput,
	WarnChip,
} from '@components';
import { formatPriceToFinancial } from '@utils';

const NO_RATE_CARD_REASON = 'Unable to update cost as there is no Carrier Rate card connected.';

export interface ManualCarrierCostProps {
	useUserInputCost: boolean;
	userManuallyCost: null | string;
	userManuallyFuelLevy: null | string;
	useGlobalFuelLevy: boolean;
	updateForm: (e: ChangeEvent<HTMLInputElement>) => void;
	newCarrierManualCost?: number;
	connect?: (field: string) => Record<string, any>;
	onFieldFocus?: (field: string) => void;
	disabled?: boolean;
}

/** The carrier cost stated by hand, for an allocation with no rate card to be repriced from. */
export const ManualCarrierCost = (props: ManualCarrierCostProps) => {
	const {
		useUserInputCost,
		userManuallyCost,
		userManuallyFuelLevy,
		useGlobalFuelLevy,
		updateForm,
		newCarrierManualCost = 0,
		connect,
		onFieldFocus,
		disabled = false,
	} = props;

	return (
		<>
			<Spacer size={8} />
			<WarnChip text={NO_RATE_CARD_REASON} stretch />
			<Spacer size={8} />
			<Checkbox
				name='use_user_input_cost'
				label='I want to manually enter the new cost'
				value=''
				checked={useUserInputCost}
				onChange={updateForm}
				disabled={disabled}
			/>
			<Spacer size={8} />
			{useUserInputCost && (
				<>
					<Grid columns={3}>
						<TextInput
							name='user_manually_cost'
							label='++ Cost($)'
							value={userManuallyCost ?? ''}
							onChange={updateForm}
							keepErrorSpace={false}
							disabled={disabled}
							{...(connect?.('user_manually_cost') ?? {})}
							onFocus={() => onFieldFocus?.('user_manually_cost')}
						/>
						<TextInput
							name='user_manually_fuel_levy'
							label='Current fuel (%)'
							value={userManuallyFuelLevy ?? ''}
							onChange={updateForm}
							keepErrorSpace={false}
							disabled={disabled || useGlobalFuelLevy}
							{...(connect?.('user_manually_fuel_levy') ?? {})}
							onFocus={() => onFieldFocus?.('user_manually_fuel_levy')}
						/>
						<div />
						<Checkbox
							name='use_global_fuel_levy'
							label='Use global fuel levy (%)'
							value=''
							checked={useGlobalFuelLevy}
							onChange={updateForm}
							disabled={disabled}
						/>
					</Grid>
					<Spacer size={16} />
					<Grid columns={2} gap={'4px'} columnTemplate={'130px 1fr'}>
						<Label>New Total Cost</Label>
						{newCarrierManualCost > 0 && <Text>${formatPriceToFinancial(`${newCarrierManualCost}`)}</Text>}
					</Grid>
				</>
			)}
		</>
	);
};
